import { render, staticRenderFns } from "./BatchInquiryCreate.vue?vue&type=template&id=7e374676"
import script from "./BatchInquiryCreate.vue?vue&type=script&lang=js"
export * from "./BatchInquiryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports